module.exports = __webpack_public_path__ + "static/media/signage-indoor-img42.cd7ca0d6.jpg";